import { Contact } from '../../../types/listing/contact';

// create blank contact
export const createBlankContact = () => {
    const blankContact:Contact = {
        'contactId': undefined,
        'tempId': false,
        'firstName': '',
        "brokerType": '',
        'lastName': '',
        'email': '',
        'phone': '',
        'location': '',
        'title': '',
        'additionalFields': {
            'license': ''
        }
    };
    return blankContact;
}